const emptyEnv = Object.keys(import.meta).length === 0;
export const config = {
  auth0Audience: !emptyEnv ? import.meta.env.VITE_AUTH0_AUDIENCE : "fake-audience",
  endPoint: !emptyEnv ? import.meta.env.VITE_FRONTERA_GRAPHQL_ENDPOINT : "fake-endpoint",
  baseRestApiUrl: !emptyEnv ? import.meta.env.VITE_FRONTERA_REST_API_ENDPOINT : "fake-endpoint",
  REPORT_POLLING_INTERVAL: Number(import.meta.env.VITE_REPORT_POLLING_INTERVAL),
};
